export default "__VITE_ASSET__mKPZFU$U__"